import type { Mutation } from 'vuex'
import type { Params, State, DetailType } from './state'
import type { UserInfo } from '@/views/userInfo/user-info-reference/types'

import actionTypes from './actionTypes'

const mutations: { [actionTypes: string]: Mutation<State> } = {
  [actionTypes.SET_SUER_INFO_DETAIL]: (state: State, item: any) => {
    state.detail = [...item]
  },

  // 利用者参照画面ユーザーインフォメーション
  [actionTypes.SET_USER_INFO_ITEM]: (state, item: UserInfo): void => {
    state.userInfoDetail = item
  },

  // 利用者参照画面編集モードステータス
  [actionTypes.SET_EDIT_MODEL_STATUS]: (state, status: boolean): void => {
    state.isEditModel = status
  },

  // 利用者新規画面編集モードステータス
  [actionTypes.SET_ADD_MODEL_STATUS]: (state, status: boolean): void => {
    state.isAddModel = status
  },

  [actionTypes.SET_PARAMS]: (state: State, item: Params) => {
    state.userParams = { ...item }
  },
  [actionTypes.SET_TOTAL_COUNT]: (state: State, count: number) => {
    state.total_count = count
  },
}

export default mutations
